import type React from 'react';

const TYPOGRAPHY_KEYS = [
  'fontFamily',
  'fontSize',
  'fontWeight',
  'lineHeight',
  'letterSpacing',
] as const;

type TypographyKeys = (typeof TYPOGRAPHY_KEYS)[number];

type TypographyCSSProps = Pick<React.CSSProperties, TypographyKeys>;

export const getTypographyFromTheme = (typography: TypographyCSSProps): TypographyCSSProps => {
  const { fontFamily, fontSize, fontWeight, lineHeight, letterSpacing } = typography;
  return { fontFamily, fontSize, fontWeight, lineHeight, letterSpacing };
};
